import { render, staticRenderFns } from "./FieldNumber.vue?vue&type=template&id=68937bad&scoped=true"
import script from "./FieldNumber.vue?vue&type=script&lang=ts"
export * from "./FieldNumber.vue?vue&type=script&lang=ts"
import style0 from "./FieldNumber.vue?vue&type=style&index=0&id=68937bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68937bad",
  null
  
)

export default component.exports